export default __webpack_public_path__ + "src/images/btn_close-485563.png";